// langs
export const FR_FR = 'fr-FR';
export const EN_US = 'en-US';
export const EN_GB = 'en-GB';

export const localeIds = /** @type {const} */ ([
	FR_FR,
	EN_GB,
	EN_US,
]);

/** @type {{ [index in typeof localeIds[number]]: { flag: string, alias?: string }}} */
export const locales = {
	[FR_FR]: { flag: 'fr' },
	[EN_US]: { flag: 'us' },
	[EN_GB]: { flag: 'gb' },
};

export const defaultLocale = locales[FR_FR];

/**
 *
 * @param {typeof localeIds[number]} lang
 * @returns {string}
 */
export const langToFlag = lang => {
	const locale = locales[lang];
	if (locale) {
		return locales[lang].flag;
	}
	return defaultLocale.flag;
};
